import React, { Component } from 'react';
import { startLoadingAnimate, stopLoadingAnimate } from "services/ducks/loading";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { withSnackbar } from "notistack";
import { withRouter } from "react-router-dom";
import { Row, Col } from "react-bootstrap";
import { ContainerTitle, FullSizedButton } from '../styles';
import { ItemsSubtitle, ModalBody, ModalCloseButton, SessionTitle, SessionContent, ChartSubtitle } from "./styles";
import { Button, Table, TableHead, TableCell, TableBody, TableRow } from "@material-ui/core";
import { TextField, Slider, Modal } from "@material-ui/core";
import { faQuestion, faPiggyBank } from '@fortawesome/free-solid-svg-icons';
import * as FontAwesome from '@fortawesome/react-fontawesome';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import api from "services/structure/api";
import NumberFormat from "react-number-format";
import { parseDateAndFormat } from 'services/structure/dateUtils';
import { numberFormatter } from "services/structure/numberUtils";
import { Chart } from "react-google-charts";
import { isMobile, isMobileOnly } from "react-device-detect";

class Simulador extends Component {
    constructor(props) {
        super(props);
        this.obterDadosSimulacao();
    }

    state = {
        info: {}
    }

    obterDadosSimulacao = () => {
        this.props.startLoadingAnimate();
        api.post("/simulador/dados-iniciais-simulador-plano-cd")
            .then(response => { 
                this.setState( { info: response.data }); 
            })
            .catch((e) => {
              const mensagem = "Não foi possível conectar-se ao servidor. Recarregue a página! ";
              this.props.enqueueSnackbar(mensagem, { variant: 'error' });
              console.log(e);
            })
            .finally(() => this.props.stopLoadingAnimate());
    }
    
    // TODO levar isso ao number utils
    converterDecimalEmPercentual = (val) => {
        if(Number.isNaN(val) || typeof(val) == "undefined"){
            val = 0;
        }
        return val * 100;
    }

    formatarPercentual = defaultProperty => {
        return (val) => {
        if (Number.isNaN(val)) {
            val = this.converterDecimalEmPercentual(this.state.info[defaultProperty]);
        }
        if (Number.isNaN(val)) {
            return '';
        }
        return numberFormatter.format(val) + '%';
        }
    }

    converterDecimalEmPercentualFormatado = nomeAtributo => {
        let val = this.state.info[nomeAtributo + 'InputText'];
        if (val != null) {
            return val;
        }
        val = this.state.info[nomeAtributo];
        if (Number.isNaN(val)) {
            return '';
        }
        return numberFormatter.format(this.converterDecimalEmPercentual(val));
    }

    converterPercentualFormatadoEmDecimal = (val) => {
        val = val.replace(/[^\d|,]/g, '');
        return this.converterPercentualEmDecimal(numberFormatter.unformat(val));
    }

    converterPercentualEmDecimal = (val) => {
        return val / 100;
    }

    changePercentualTextField = nomeAtributo => {
      return e => {
        const info = this.state.info;
        let valorInput = e.target.value;
        if (valorInput) {
            valorInput = valorInput.replace(/[^\d|,]/g, ""); // tira o que nao eh digito ou virgula
            valorInput = valorInput.replace(/,(.*,.*)/g, "$1"); // deixa somente a ultima virgula
        }
        let valor = this.converterPercentualFormatadoEmDecimal(valorInput);
        if (valor > 1) {
            valor = 1;
            valorInput = "100,00";
        }
        if (valor < 0) {
            valor = 0;
            valorInput = "";
        }
        info[nomeAtributo] = valor;
        info[nomeAtributo + 'InputText'] = valorInput;
        this.setState({ info: info });
      }
    }

    changePercentualSlider = (nomeAtributo, novoValor) => {
      let info = this.state.info;
      const novoPercentualConvertido = this.converterPercentualEmDecimal(novoValor);
      info[nomeAtributo] = novoPercentualConvertido;
      info[nomeAtributo + 'InputText'] = null;
      this.setState({ info: info });
    }

    changeValorAtributoNumerico = (nomeAtributo, e) => {
      let val = numberFormatter.unformat(isNaN(e.floatValue) ? 0 : e.floatValue);
      if (!Number.isNaN(val)) {
        const info = this.state.info;
        info[nomeAtributo] = val
        this.setState({ info: info });
      }
    }

    executarSimulacao = () => {
        this.props.startLoadingAnimate();

        const info = this.state.info;
        const parametros = {
            idadeAtual: info.idadeAtual,
            percentualCrescimentoSalarialAnual: info.crescimentoSalarial,
            percentualRentabilidadeAnualDoPlano: info.retornoInvestimentos,
            valorSalarioInicial: info.valorSalarioParticipacao,
            percentualContribuicaoNormalPacelaUm: info.percentualParcela1,
            percentualContribuicaoNormalPacelaDois: info.percentualContribuicaoNormalPacelaDois,
            percentualContribucaoVoluntariaParticipante: info.percentualContribucaoVoluntariaParticipante, 
            valorAporteImediato: info.valorAporteImediato,
            percentualSaqueBeneficio: info.percentualSaqueBeneficio,
            prazoDeterminadoBeneficio: info.prazoDeterminadoBeneficio,
            percentualBeneficioMensal: info.percentualBeneficioMensal,
            idadeAposentadoria: info.idadeAposentadoria,
            valorUltimoSalarioAntesAposentadoria: info.valorSalarioParticipacao * ((info.crescimentoSalarial + 1) ** (info.idadeAposentadoria - info.idadeAtual)),
            retornoInvestimentos: info.retornoInvestimentos,
            crescimentoSalarial: info.crescimentoSalarial,
            //prazoDeterminado: info.prazoDeterminado,
            numeroDependentesIR: info.dependentesIR,
            isContribuicaoValorAbsoluto: info.isContribuicaoValorAbsoluto,
            valorAporteEventualPeriodico: info.valorAporteEventualPeriodico,
            valorContribuicaiParticipante: info.valorContribuicaiParticipante,
            numeroDePagamentosPorAno: info.qtParcelasAnuais
        }
        
        api.post("/simulador/simulador-plano-cd", parametros)
            .then(response => { 
                const simulacao = response.data;
                
                if (!simulacao.exibirResultado) {
                    this.props.enqueueSnackbar(simulacao.mensagem, { variant: 'error' });
                    return;
                }

                // Formatting values
                const saldoChartHeader = ["TIPO", "VALOR"];
                const saldoChartValues = simulacao.saldoContaProjetado?.saldo?.map(item => {
                    const valor = item.dados;
                    return [ item.rotulo + " - R$ " + numberFormatter.format(valor), valor ]
                });

                // Formatting colors
                const slicesColorsChart = simulacao.saldoContaProjetado?.saldo?.reduce((map, item, index) => {
                    map[index] = { color: item.corFundo };
                    return map
                }, {});

                this.setState( { 
                    simulacao: simulacao, 
                    slicesColorsChart: slicesColorsChart, 
                    saldoChart: [ saldoChartHeader ].concat(saldoChartValues) 
                }); 
            })
            .catch((e) => {
              const mensagem = "Não foi possível conectar-se ao servidor. Recarregue a página! ";
              this.props.enqueueSnackbar(mensagem, { variant: 'error' });
              console.log(e);
            })
            .finally(() => this.props.stopLoadingAnimate());
    }

    closeModalSimulacao = () => this.setState({simulacao: undefined})

    renderEntradaValores = () => {
        return  (
            <div className='simulador-entrada-valores'>
                <Row>
                    <Col sm={6}>
                        <ContainerTitle className="title-simulador">SIMULADOR</ContainerTitle>   
                        <Row className="simulador-cliente">
                            <ItemsSubtitle>Idade: </ItemsSubtitle>
                            <span>
                                <NumberFormat
                                    value={this.state?.info?.idadeAtual}
                                    displayType={"text"}
                                    decimalSeparator={","}
                                    decimalPrecision={2}
                                    thousandSeparator={"."}
                                    isNumericString={true}
                                    prefix={"R$ "}
                                /> Anos</span>
                        </Row>
                        {
                             !this.state?.info?.contribuicaoValorAbsoluto &&
                            <Row className="simulador-cliente">
                                <ItemsSubtitle>Salário de Participação: </ItemsSubtitle>
                                <span>
                                    <NumberFormat
                                        value={this.state?.info?.valorSalarioParticipacao?.toFixed(2)}
                                        displayType={"text"}
                                        decimalSeparator={","}
                                        decimalPrecision={2}
                                        thousandSeparator={"."}
                                        isNumericString={true}
                                        prefix={"R$ "}
                                        />
                                </span>
                            </Row>
                        }
                        <Row className="simulador-cliente">
                            <ItemsSubtitle>Saldo de Conta Total: </ItemsSubtitle>
                            <span>
                                <NumberFormat
                                    value={this.state?.info?.saldoContaAVista?.toFixed(2)}
                                    displayType={"text"}
                                    decimalSeparator={","}
                                    decimalPrecision={2}
                                    thousandSeparator={"."}
                                    isNumericString={true}
                                    prefix={"R$ "}
                                />
                            </span>
                        </Row>
                        {
                            !this.state.info?.permitirEdicaoPercentualContribuicaoParcela1 &&
                            <Row className="simulador-cliente">
                                <ItemsSubtitle>{this.state.info?.lblAreaParticipanteParcela1}: </ItemsSubtitle>
                                <span>
                                    <NumberFormat
                                        value={this.state?.info?.parcela1ContribuicaoNormal?.toFixed(2)}
                                        displayType={"text"}
                                        decimalSeparator={","}
                                        decimalPrecision={2}
                                        thousandSeparator={"."}
                                        isNumericString={true}
                                        prefix={"R$ "}
                                    />
                                </span>
                            </Row>
                        }
                        <Row className="simulador-cliente">
                            <ItemsSubtitle>Data da simulação: </ItemsSubtitle>
                            <span>{parseDateAndFormat(this.state?.info?.dataCalculo)}</span>
                        </Row>
                    </Col>
                    <div className='col-3'>
                        <img src={process.env.PUBLIC_URL + '/simulador-subtitle.png'} className="simulador-title" alt="" />
                    </div> 
                    <div className='col-3'>
                    </div>
                </Row>
                <div className='col simulador-aviso'>
                    * Preencha os campos abaixo de acordo com sua vontade e aperte o botão "Simular". 
                    Caso tenha alguma dúvida sobre seu significado clique sobre o respectivo botão de dúvida.
                    &nbsp;
                    <b> 
                        A simulação não representa promessa de rentabilidade ou 
                        garantia de nível de benefícios.
                    </b>
                </div>
                <Row>
                    <Col sm={6} >
                        <h4 className='simulador-subtitle-columns'>ACUMULAÇÃO DOS RECURSOS</h4>
                        <div className='simulador-col-1'>
                            <div>
                                {
                                    !this.state?.info?.contribuicaoValorAbsoluto &&
                                    <div className="input-text-percent">
                                        <TextField
                                            fullWidth
                                            variant="outlined"
                                            margin="normal"
                                            label="Crescimento Salarial"
                                            name="crescimentoSalarial"
                                            onChange={this.changePercentualTextField('crescimentoSalarial')}
                                            value={this.converterDecimalEmPercentualFormatado('crescimentoSalarial')}
                                        />
                                        <span className="input-percent-suffix">%</span>
                                        <OverlayTrigger placement="bottom"
                                            overlay={<Tooltip className='simulador-help-button-msg'>{this.state?.info?.hintCrescimentoSalarial}</Tooltip>}>
                                            <Button className="simulador-help-button">
                                                <FontAwesome.FontAwesomeIcon icon={faQuestion} className="question-icon"/>
                                            </Button>
                                        </OverlayTrigger>
                                    </div>
                                }
                                <div className="input-text-percent">
                                    <TextField
                                        fullWidth
                                        variant="outlined"
                                        margin="normal"
                                        label="Retorno dos Investimentos"
                                        name="retornoInvestimentos"
                                        onChange={this.changePercentualTextField('retornoInvestimentos')}
                                        value={this.converterDecimalEmPercentualFormatado('retornoInvestimentos')}
                                    />
                                    <span className="input-percent-suffix">%</span>
                                    <OverlayTrigger placement="bottom"
                                        overlay={<Tooltip className='simulador-help-button-msg'>{this.state?.info?.hintRetornoInvestimentos}</Tooltip>}>
                                        <Button className="simulador-help-button">
                                            <FontAwesome.FontAwesomeIcon icon={faQuestion} className="question-icon"/>
                                        </Button>
                                    </OverlayTrigger>
                                </div>
                            </div>
                            { 
                                !this.state?.info?.contribuicaoValorAbsoluto && this.state.info?.permitirEdicaoPercentualContribuicaoParcela1 &&
                                <div class="simulador-recebimento-subtitle">
                                    <p>{this.state.info?.lblAreaParticipanteParcela1}</p>
                                    <div className="percent-with-slider">
                                        <span className="slider-component">
                                            <Slider value={this.converterDecimalEmPercentual(this.state.info?.percentualParcela1)} 
                                            onChange={(_, newValue) => this.changePercentualSlider('percentualParcela1', newValue)}
                                            min={(this.state.info?.minPercentualParcela1 || 0) * 100}
                                            max={(this.state.info?.maxPercentualParcela1 || 0) * 100} size='large'
                                            step={0.25} valueLabelFormat={this.formatarPercentual('percentualParcela1')}
                                            />
                                        </span>
                                        <div className="input-text-percent">
                                            <TextField
                                                fullWidth
                                                variant="outlined"
                                                margin="normal"
                                                label="%"
                                                name="percentualParcela1"
                                                onChange={this.changePercentualTextField('percentualParcela1')}
                                                value={this.converterDecimalEmPercentualFormatado('percentualParcela1')}
                                            />
                                            <span className="input-percent-suffix">%</span>
                                            <OverlayTrigger placement="bottom"
                                                overlay={<Tooltip className='simulador-help-button-msg'>{this.state?.info?.hintParcela1}</Tooltip>}>
                                                <Button className="simulador-help-button">
                                                    <FontAwesome.FontAwesomeIcon icon={faQuestion} className="question-icon"/>
                                                </Button>
                                            </OverlayTrigger>
                                        </div>
                                    </div>
                                </div>
                            } 
                            { 
                                !this.state?.info?.contribuicaoValorAbsoluto && this.state.info?.permitirEdicaoPercentualContribuicaoParcela2 &&
                                <div class="simulador-recebimento-subtitle">
                                    <p>{this.state.info?.lblAreaParticipanteParcela2}</p>
                                    <div className="percent-with-slider">
                                        <span className="slider-component">
                                            <Slider value={this.converterDecimalEmPercentual(this.state.info?.percentualContribuicaoNormalPacelaDois)} 
                                            onChange={(_, newValue) => this.changePercentualSlider('percentualContribuicaoNormalPacelaDois', newValue)}
                                            min={(this.state.info?.minPercentualParcela2 || 0) * 100}
                                            max={(this.state.info?.maxPercentualParcela2 || 0) * 100} size='large'
                                            step={0.25} valueLabelFormat={this.formatarPercentual('percentualContribuicaoNormalPacelaDois')}
                                            />
                                        </span>
                                        <div className="input-text-percent">
                                            <TextField
                                                fullWidth
                                                variant="outlined"
                                                margin="normal"
                                                label="%"
                                                name="percentualContribuicaoNormalPacelaDois"
                                                onChange={this.changePercentualTextField('percentualContribuicaoNormalPacelaDois')}
                                                value={this.converterDecimalEmPercentualFormatado('percentualContribuicaoNormalPacelaDois')}
                                            />
                                            <span className="input-percent-suffix">%</span>
                                            <OverlayTrigger placement="bottom"
                                                overlay={<Tooltip className='simulador-help-button-msg'>{this.state?.info?.hintParcela2}</Tooltip>}>
                                                <Button className="simulador-help-button">
                                                    <FontAwesome.FontAwesomeIcon icon={faQuestion} className="question-icon"/>
                                                </Button>
                                            </OverlayTrigger>
                                        </div>
                                    </div>
                                </div>
                            }
                            {
                                !this.state?.info?.contribuicaoValorAbsoluto && 
                                <div class="simulador-recebimento-subtitle">
                                    <p>{this.state.info?.lblAreaParticipanteVoluntaria}</p>
                                    <div className="percent-with-slider">
                                        <span className="slider-component">
                                            <Slider value={this.converterDecimalEmPercentual(this.state.info?.percentualContribucaoVoluntariaParticipante)} 
                                            onChange={(_, newValue) => this.changePercentualSlider('percentualContribucaoVoluntariaParticipante', newValue)}
                                            min={(this.state.info?.minPercentualVoluntaria || 0) * 100}
                                            max={(this.state.info?.maxPercentualVoluntaria || 0) * 100} size='large'
                                            step={0.25} valueLabelFormat={this.formatarPercentual('percentualContribucaoVoluntariaParticipante')}
                                            />
                                        </span>
                                        <div className="input-text-percent">
                                            <TextField
                                                fullWidth
                                                variant="outlined"
                                                margin="normal"
                                                label="%"
                                                name="percentualContribucaoVoluntariaParticipante"
                                                onChange={this.changePercentualTextField('percentualContribucaoVoluntariaParticipante')}
                                                value={this.converterDecimalEmPercentualFormatado('percentualContribucaoVoluntariaParticipante')}
                                            />
                                            <span className="input-percent-suffix">%</span>
                                            <OverlayTrigger placement="bottom"
                                                overlay={<Tooltip className='simulador-help-button-msg'>{this.state?.info?.hintContribuicaoVoluntaria}</Tooltip>}>
                                                <Button className="simulador-help-button">
                                                    <FontAwesome.FontAwesomeIcon icon={faQuestion} className="question-icon"/>
                                                </Button>
                                            </OverlayTrigger>
                                        </div>
                                    </div>
                                </div>
                            }
                            <div>
                                {
                                    !this.state?.info?.contribuicaoValorAbsoluto &&
                                    <div className="input-text-percent">
                                        <NumberFormat
                                            value={this.state.info?.valorAporteImediato}
                                            thousandSeparator="."
                                            decimalSeparator=","
                                            customInput={TextField}
                                            onValueChange={e => this.changeValorAtributoNumerico('valorAporteImediato', e)}
                                            variant="outlined"
                                            decimalScale={2}
                                            fixedDecimalScale={2}
                                            label="Aporte Voluntário"
                                            name="valorAporteImediato"
                                            prefix={"R$ "}
                                            fullWidth
                                            className="MuiFormControl-marginNormal"
                                        />
                                        {/* <span className="input-number-suffix"></span>
                                        <OverlayTrigger placement="bottom"
                                            overlay={<Tooltip className='simulador-help-button-msg'>{this.state?.info?.hintValorAporteVoluntario}</Tooltip>}>
                                            <Button className="simulador-help-button">
                                                <FontAwesome.FontAwesomeIcon icon={faQuestion} className="question-icon"/>
                                            </Button>
                                        </OverlayTrigger> */}
                                    </div>
                                }
                                {
                                    this.state?.info?.contribuicaoValorAbsoluto &&
                                    <div className="input-text-absolute">     
                                        <NumberFormat
                                            value={this.state.info?.valorContribuicaiParticipante}                  
                                            thousandSeparator="."
                                            decimalSeparator=","
                                            defaultValue={0}
                                            customInput={TextField}
                                            onValueChange={e => this.changeValorAtributoNumerico('valorContribuicaiParticipante', e)}
                                            variant="outlined"
                                            decimalScale={0}
                                            fixedDecimalScale={0}
                                            label={this.state.info?.lblAreaParticipanteParcela1}
                                            name="valorContribuicaiParticipante"
                                            fullWidth
                                            className="MuiFormControl-marginNormal"
                                        />
                                        <span className="input-number-suffix"></span>
                                        <OverlayTrigger placement="bottom"
                                            overlay={<Tooltip className='simulador-help-button-msg'>{this.state?.info?.hintParcela1}</Tooltip>}>
                                            <Button className="simulador-help-button">
                                                <FontAwesome.FontAwesomeIcon icon={faQuestion} className="question-icon"/>
                                            </Button>
                                        </OverlayTrigger>
                                    </div>
                                }
                                {
                                    this.state?.info?.contribuicaoValorAbsoluto &&
                                    <div className="input-text-absolute">     
                                        <NumberFormat
                                            value={this.state.info?.valorAporteEventualPeriodico}                  
                                            thousandSeparator="."
                                            defaultValue={0}
                                            decimalSeparator=","
                                            customInput={TextField}
                                            onValueChange={e => this.changeValorAtributoNumerico('valorAporteEventualPeriodico', e)}
                                            variant="outlined"
                                            decimalScale={0}
                                            fixedDecimalScale={0}
                                            label={this.state.info?.lblAreaParticipanteVoluntaria}
                                            name="valorAporteEventualPeriodico"
                                            fullWidth
                                            className="MuiFormControl-marginNormal"
                                        />
                                        <span className="input-number-suffix"></span>
                                        <OverlayTrigger placement="bottom"
                                            overlay={<Tooltip className='simulador-help-button-msg'>{this.state?.info?.hintContribuicaoVoluntaria}</Tooltip>}>
                                            <Button className="simulador-help-button">
                                                <FontAwesome.FontAwesomeIcon icon={faQuestion} className="question-icon"/>
                                            </Button>
                                        </OverlayTrigger>
                                    </div>
                                }
                                <div className="input-text-absolute">     
                                    <NumberFormat
                                        value={this.state.info?.idadeAposentadoria}          
                                        defaultValue="0"        
                                        thousandSeparator="."
                                        decimalSeparator=","
                                        customInput={TextField}
                                        onValueChange={e => this.changeValorAtributoNumerico('idadeAposentadoria', e)}
                                        variant="outlined"
                                        decimalScale={0}
                                        fixedDecimalScale={0}
                                        label="Idade de Aposentadoria"
                                        name="aposentadoria"
                                        fullWidth
                                        className="MuiFormControl-marginNormal"
                                    />
                                </div>
                            </div>
                        </div>
                    </Col>
                    <Col sm={6} >
                        <h4 className='simulador-subtitle-columns'>RECEBIMENTO DO BENEFÍCIO</h4>
                        { this.state?.info?.lblAreaParticipanteContaBeneficio &&
                        <div className='simulador-col-1'>
                            <div class="simulador-recebimento-subtitle">
                                <p>{this.state.info?.lblAreaParticipanteContaBeneficio}</p>
                                <div className="percent-with-slider">
                                    <span className="slider-component">
                                        <Slider value={this.converterDecimalEmPercentual(this.state.info?.percentualSaqueBeneficio)} 
                                            onChange={(_, newValue) => this.changePercentualSlider('percentualSaqueBeneficio', newValue)}
                                            min={(this.state.info?.minPercentualContaBeneficio || 0) * 100}
                                            max={(this.state.info?.maxPercentualContaBeneficio || 0) * 100} size='large'
                                            step={0.25} valueLabelFormat={this.formatarPercentual('percentualSaqueBeneficio')}
                                        />
                                    </span>
                                    <div className="input-text-percent">
                                        <TextField
                                            fullWidth
                                            variant="outlined"
                                            margin="normal"
                                            label="%"
                                            name="percentualSaqueBeneficio"
                                            onChange={this.changePercentualTextField('percentualSaqueBeneficio')}
                                            value={this.converterDecimalEmPercentualFormatado('percentualSaqueBeneficio')}
                                        />
                                        <span className="input-percent-suffix">%</span>
                                    </div>
                                </div>
                            </div>
                        </div> }
                        <div className='simulador-col-1'>
                            <div className="input-text-absolute">
                                <NumberFormat
                                    value={this.state.info?.prazoDeterminadoBeneficio}                  
                                    thousandSeparator="."
                                    decimalSeparator=","
                                    customInput={TextField}
                                    onValueChange={e => this.changeValorAtributoNumerico('prazoDeterminadoBeneficio', e)}
                                    variant="outlined"
                                    decimalScale={0}
                                    label="Prazo Determinado (anos)"
                                    name="prazoDeterminadoBeneficio"
                                    fullWidth
                                    className="MuiFormControl-marginNormal"
                                />
                                <span className="input-number-suffix"></span>
                                <OverlayTrigger placement="bottom"
                                    overlay={<Tooltip className='simulador-help-button-msg'>{this.state?.info?.hintPrazoDeterminado}</Tooltip>}>
                                    <Button className="simulador-help-button">
                                        <FontAwesome.FontAwesomeIcon icon={faQuestion} className="question-icon"/>
                                    </Button>
                                </OverlayTrigger>
                            </div>
                        </div>
                        { this.state?.info?.lblAreaParticipanteSaldoConta &&
                        <div className='simulador-col-1'>
                            <div class="simulador-recebimento-subtitle">
                                <p>{this.state.info?.lblAreaParticipanteSaldoConta}</p>
                                <div className="percent-with-slider">
                                    <span className="slider-component">
                                        <Slider value={this.converterDecimalEmPercentual(this.state.info?.percentualBeneficioMensal)} 
                                        onChange={(_, newValue) => this.changePercentualSlider('percentualBeneficioMensal', newValue)}
                                        min={(this.state.info?.minPercentualSaldoConta || 0) * 100}
                                        max={(this.state.info?.maxPercentualSaldoConta || 0) * 100} size='large'
                                        step={this.state.info?.stepsPercentualMensalBeneficio || 0.25} valueLabelFormat={this.formatarPercentual('percentualBeneficioMensal')}
                                        />
                                    </span>
                                    <div className="input-text-percent">
                                        <TextField
                                            fullWidth
                                            variant="outlined"
                                            margin="normal"
                                            label="%"
                                            name="percentualBeneficioMensal"
                                            onChange={this.changePercentualTextField('percentualBeneficioMensal')}
                                            value={this.converterDecimalEmPercentualFormatado('percentualBeneficioMensal')}
                                        />
                                        <span className="input-percent-suffix">%</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        }
                        <div className='simulador-col-1'>
                            {
                                this.state?.info?.permiteAbonoAnual &&
                                <div className="input-text-absolute">     
                                    <NumberFormat
                                        value={this.state.info?.qtParcelasAnuais}                  
                                        thousandSeparator="."
                                        defaultValue={0}
                                        decimalSeparator=","
                                        customInput={TextField}
                                        onValueChange={e => this.changeValorAtributoNumerico('qtParcelasAnuais', e)}
                                        variant="outlined"
                                        decimalScale={0}
                                        fixedDecimalScale={0}
                                        label="Quantas Parcelas Anuais?"
                                        name="qtParcelasAnuais"v
                                        fullWidth
                                        className="MuiFormControl-marginNormal"
                                    />
                                    <span className="input-number-suffix"></span>
                                    <OverlayTrigger placement="bottom"
                                        overlay={<Tooltip className='simulador-help-button-msg'>{this.state?.info?.hintQtParcelasAnuais}</Tooltip>}>
                                        <Button className="simulador-help-button">
                                            <FontAwesome.FontAwesomeIcon icon={faQuestion} className="question-icon"/>
                                        </Button>
                                    </OverlayTrigger>
                                </div>
                            }
                            {
                            this.state?.info?.exibirQuantidadeDependentesIR &&
                            <div className="input-text-absolute">
                                <NumberFormat
                                    value={this.state.info?.dependentesIR}                  
                                    thousandSeparator="."
                                    decimalSeparator=","
                                    customInput={TextField}
                                    onValueChange={e => this.changeValorAtributoNumerico('dependentesIR', e)}
                                    variant="outlined"
                                    decimalScale={0}
                                    fixedDecimalScale={0}
                                    label="Dependentes para o IR"
                                    name="dependentesIR"
                                    fullWidth
                                    className="MuiFormControl-marginNormal"
                                />
                                <span className="input-number-suffix"></span>
                                <OverlayTrigger placement="bottom"
                                    overlay={<Tooltip className='simulador-help-button-msg'>{this.state?.info?.hintDependentesIR}</Tooltip>}>
                                    <Button className="simulador-help-button">
                                        <FontAwesome.FontAwesomeIcon icon={faQuestion} className="question-icon"/>
                                    </Button>
                                </OverlayTrigger>
                            </div>
                            }
                        </div>
                        <div className={isMobile ? '' : 'simulador-col-1'}>
                            <div class="simulador-recebimento-do-beneficio">
                                <FullSizedButton type="submit" variant="contained" className="simulador-saving"
                                    onClick={this.executarSimulacao}>
                                    <i class="fas fa-piggy-bank simulador-icon-saving"></i>
                                    <span className="simulador-btn">SIMULAR</span>
                                </FullSizedButton>
                            </div>
                        </div>
                    </Col> 
                </Row>
                <Modal open={this.state.simulacao} onClose={this.closeModalSimulacao} className="simulacao-modal">
                    <ModalBody>
                        <ModalCloseButton 
                            variant="contained" className="close-modal-button"
                            onClick={this.closeModalSimulacao}>X</ModalCloseButton>
                    {
                        this.state.simulacao && this.renderSimulacao()
                    }
                    </ModalBody>
                </Modal>
            </div>
        )
    }

    renderBeneficioProjetadoMobile() {
        return (
            <SessionContent className='beneficio-projetado mobile'>
                {this.renderBeneficioProjetadoMobileRow()}
            </SessionContent>
        )
    }
    renderBeneficioProjetadoMobileRow() {
        if (!this.state.simulacao?.beneficioProjetado?.length) {
            return (<div></div>);
        }
        return this.state.simulacao.beneficioProjetado.map( row => {
            return (
                <div className='card-row'>
                    <div className='card-cell titulo'>
                        <div className="card-cell-title">{row.titulo}</div>
                    </div>
                    <div className='card-cell prazo-determinado'>
                        <div className="card-cell-title">Prazo determinado</div>
                        <div className="card-cell-value">
                            <NumberFormat
                                value={row.prazoDeterminadoBeneficio}
                                displayType={"text"}
                                thousandSeparator="."
                                decimalSeparator=","
                                decimalScale={2}
                                prefix={"R$ "}
                            />
                        </div>
                    </div>
                    {
                        this.state?.simulacao?.exibirQuadroPrazoIndeterminado &&
                        <div className='card-cell prazo-indeterminado'>
                            <div className="card-cell-title">Prazo indeterminado</div>
                            <div className="card-cell-value">
                                <NumberFormat
                                    value={row.prazoIndeterminadoBeneficio}
                                    displayType={"text"}
                                    thousandSeparator="."
                                    decimalSeparator=","
                                    decimalScale={2}
                                    prefix={"R$ "}
                                />
                            </div>
                        </div>
                    }
                    <div className='card-cell saldo-conta'>
                        <div className="card-cell-title">Saldo de conta</div>
                        <div className="card-cell-value">
                            <NumberFormat
                                value={row.percentualSaldoContaBeneficio}
                                displayType={"text"}
                                thousandSeparator="."
                                decimalSeparator=","
                                decimalScale={2}
                            />
                        </div>
                    </div>
                </div>
            )
        });
    }

    renderBeneficioProjetadoDesktop() {
        return (
            
            <SessionContent className='beneficio-projetado'>
                
                <Table>
                    <TableHead>
                        <TableCell></TableCell>
                        <TableCell><b>Prazo Determinado</b></TableCell>
                        {
                            this.state?.simulacao?.exibirQuadroPrazoIndeterminado &&
                            <TableCell><b>Prazo Indeterminado</b></TableCell>
                        }
                        {
                            this.state?.simulacao?.exibirQuadroSaldoConta &&
                            <TableCell><b>% Saldo de Conta</b></TableCell>
                        }
                    </TableHead>
                    <TableBody>
                        {this.renderBeneficioProjetadoDesktopRow()}
                    </TableBody>
                </Table>
            </SessionContent>
        )
    }

    renderBeneficioProjetadoDesktopRow() {
        if (!this.state.simulacao?.beneficioProjetado?.length) {
            return (<TableRow></TableRow>);
        }
        return this.state.simulacao.beneficioProjetado.map( row => {
            return (
                row.prazoDeterminadoBeneficio ?
                <TableRow>
                    <TableCell>{row.titulo}</TableCell>
                    <TableCell>
                        <NumberFormat
                            value={row.prazoDeterminadoBeneficio}
                            displayType={"text"}
                            thousandSeparator="."
                            decimalSeparator=","
                            decimalScale={2}
                            prefix={row.percentual ?  "" : "R$"}
                            suffix={row.percentual ?  "%" : ""}
                        />
                    </TableCell>
                    {
                        this.state?.simulacao?.exibirQuadroPrazoIndeterminado &&
                        <TableCell>
                        <NumberFormat
                            value={row.prazoIndeterminadoBeneficio}
                            displayType={"text"}
                            thousandSeparator="."
                            decimalSeparator=","
                            decimalScale={2}
                            prefix={row.percentual ?  "" : "R$"}
                            suffix={row.percentual ?  "%" : ""}
                            />
                        </TableCell>
                    }
                    {
                        this.state?.simulacao?.exibirQuadroSaldoConta &&
                        <TableCell>
                            <NumberFormat
                                value={row.percentualSaldoContaBeneficio}
                                displayType={"text"}
                                thousandSeparator="."
                                decimalSeparator=","
                                decimalScale={2}
                                prefix={row.percentual ?  "" : "R$"}
                                suffix={row.percentual ?  "%" : ""}
                            />
                        </TableCell>
                    }
                </TableRow>
            : null)
        });
    }

    renderSimulacao() {
        return (
            <div>
                <SessionTitle>PROJEÇÕES</SessionTitle>
                <SessionContent>
                    { this.state?.simulacao?.saldoContaBeneficio ? 
                        <Row className="simulador-cliente">
                            <ItemsSubtitle>Saldo da conta de benefício: </ItemsSubtitle>
                            <span>
                                <NumberFormat
                                    value={this.state?.simulacao?.saldoContaBeneficio}
                                    displayType={"text"}
                                    decimalSeparator={","}
                                    decimalPrecision={2}
                                    thousandSeparator={"."}
                                    isNumericString={true}
                                    prefix={"R$ "}
                                /> </span>
                        </Row> : null }
                    { this.state?.simulacao?.saldoContaAVista ? 
                        <Row className="simulador-cliente">
                            <ItemsSubtitle>Saldo à vista: </ItemsSubtitle>
                            <span>
                                <NumberFormat
                                    value={this.state?.simulacao?.saldoContaAVista}
                                    displayType={"text"}
                                    decimalSeparator={","}
                                    decimalPrecision={2}
                                    thousandSeparator={"."}
                                    isNumericString={true}
                                    prefix={"R$ "}
                                /> </span>
                        </Row> : null }
                    { this.state?.simulacao?.saldoContaAposPagamentoAVista ?
                        <Row className="simulador-cliente">
                            <ItemsSubtitle>Saldo de conta após pagamento à vista: </ItemsSubtitle>
                            <span>
                                <NumberFormat
                                    value={this.state?.simulacao?.saldoContaAposPagamentoAVista}
                                    displayType={"text"}
                                    decimalSeparator={","}
                                    decimalPrecision={2}
                                    thousandSeparator={"."}
                                    isNumericString={true}
                                    prefix={"R$ "}
                                /> </span>
                        </Row> : null }
                    { this.state?.simulacao?.fatorAtuarial ? 
                        <Row className="simulador-cliente">
                            <ItemsSubtitle>Fator atuarial: </ItemsSubtitle>
                            <span>
                                <NumberFormat
                                    value={this.state?.simulacao?.fatorAtuarial}
                                    displayType={"text"}
                                    decimalSeparator={","}
                                    decimalPrecision={6}
                                    thousandSeparator={"."}
                                    isNumericString={true}
                                /> </span>
                        </Row> : null }
                    { this.state?.simulacao?.dataSimulacao ?
                        <Row className="simulador-cliente">
                            <ItemsSubtitle>Data da simulação: </ItemsSubtitle>
                            <span>{this.state?.simulacao?.dataSimulacao}</span>
                        </Row> : null }
                </SessionContent>
                <SessionTitle>BENEFÍCIO PROJETADO</SessionTitle>
                { !isMobileOnly && this.renderBeneficioProjetadoDesktop() }
                { isMobileOnly && this.renderBeneficioProjetadoMobile() }
                <SessionTitle>SALDO DE CONTA PROJETADO</SessionTitle>
                <Row className="simulador-cliente">
                    <span>
                        <NumberFormat
                            value={this.state?.simulacao?.saldoContaProjetado?.idadeAposentadoria - this.state?.simulacao?.saldoContaProjetado?.idadeAtual }
                            displayType={"text"}
                            decimalSeparator={","}
                            decimalPrecision={2}
                            thousandSeparator={"."}
                            isNumericString={true}
                        /> Anos - Rentabilidade <NumberFormat
                            value={this.state?.simulacao?.saldoContaProjetado?.percentualRentabilidadeAoAno * 100 }
                            displayType={"text"}
                            decimalSeparator={","}
                            decimalPrecision={2}
                            decimalScale={2}
                            thousandSeparator={"."}
                            isNumericString={true}
                        />% A.A.
                    </span>
                </Row>
                { /** TODO separar o chart em um novo componente */}
                <Chart
                    width={"100%"}
                    height={"400px"}
                    chartType="PieChart"
                    loader={<div>Loading Chart</div>}
                    data={this.state?.saldoChart}
                    options={{
                        pieSliceText: "none",
                        pieHole: 0.4,
                        is3D: false,
                        slices: this.state?.slicesColorsChart,
                        tooltip: {
                            trigger: "none"
                        },
                        enableInteractivity: false,
                        legend: {
                            position: isMobileOnly ? "bottom": "right",
                            alignment: "center",
                            textStyle: {
                                fontSize: 11,
                                bold: true
                            }
                        },
                        chartArea: {
                            width: "100%",
                        } 
                    }}
                />
                <ChartSubtitle>* A simulação não representa promessa de rentabilidade ou garantia de nível de benefícios. </ChartSubtitle>
                <Row>
                    <Col sm={isMobile ? 3 : 4}></Col>
                    <Col sm={isMobile ? 6 : 4}>
                        <FullSizedButton 
                            onClick={this.closeModalSimulacao} 
                            variant="contained" 
                            fullWidth
                            className="close-modal-simulacao"
                        >
                            <FontAwesome.FontAwesomeIcon icon={faPiggyBank} className="piggybank-icon"/>
                            <span>REFAZER SIMULAÇÃO</span>
                        </FullSizedButton>
                    </Col>
                    <Col sm={isMobile ? 3 : 4}></Col>
                </Row>
            </div>
        );
    }

    render() {
        return this.renderEntradaValores();
    }
}


const mapStateToProps = (store) => ({
    authData: store.authState,
  });
  
const mapDispatchToProps = (dispatch) =>
bindActionCreators({
    startLoadingAnimate,
    stopLoadingAnimate
}, dispatch);

export default connect(
mapStateToProps,
mapDispatchToProps
)(withRouter(withSnackbar(Simulador)));